// =============================================================================
// Pintravel — People search
// =============================================================================
// Behind Home's search and the trip invite. Friends were replaced by follows
// (ADR-0007): a result says whether you follow the person, and the people you
// follow come first.
// =============================================================================

import { api } from '@/lib/api/instance';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export interface UserSearchResult {
  id: string;
  displayName: string;
  username: string | null;
  avatarUrl: string | null;
  bio: string | null;
  isPrivate: boolean;
  relation: 'none' | 'following' | 'requested';
}

export interface PaginationMeta {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export const socialKeys = {
  all: ['social'] as const,
  search: (query: string) => [...socialKeys.all, 'search', query] as const,
};

export interface SearchUsersParams {
  q: string;
  page?: number;
  perPage?: number;
}

export function useSearchUsers(params: SearchUsersParams) {
  return useQuery({
    queryKey: socialKeys.search(params.q),
    queryFn: async (): Promise<{ data: UserSearchResult[]; meta: PaginationMeta }> => {
      const searchParams = new URLSearchParams();
      searchParams.set('q', params.q);
      if (params.page) searchParams.set('page', String(params.page));
      if (params.perPage) searchParams.set('perPage', String(params.perPage));
      return api.get(`social/search?${searchParams.toString()}`).json();
    },
    enabled: params.q.trim().length >= 2,
    // Results replaced, not removed and re-added, or the list reflows on every keystroke.
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
